<template>
  <div id="diy-dialog" @click="cancelDialog">
    <!-- 自定义弹出框 -->
    <div class="content" :style="{ width: width }" @click.stop="clickNull">
      <div class="title">{{ title }}</div>
      <div class="colse" @click="cancelDialog">
        <i class="el-icon-close"></i>
      </div>

      <div class="list">
        <div class="item" v-for="(item, index) in data" :key="index">
          <div class="tit">
            <div class="tip" v-if="item.notNull">*</div>
            {{ item.title }}:
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input v-model="item.value" :placeholder="'请输入' + item.title" clearable></el-input>
          </div>
          <div class="value" v-if="item.type == 'pwd'">
            <el-input v-model="item.value" :placeholder="'请输入' + item.title" show-password clearable></el-input>
          </div>
          <div class="value" v-if="item.type == 'select'">
            <el-select v-model="item.value" placeholder="请选择" clearable>
              <el-option v-for="(it, ii) in item.options" :key="ii" :label="it.label" :value="it.value">
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'select-tips'">
            <div v-for="tip in item.options" :class="{ tip: true, 'active-tip': item.value == tip.id }"
              @click="item.value = tip.id">
              <div class="tv">{{ tip.name }}</div>
              <div class="ti"><i class="el-icon-warning"></i>{{ tip.tip }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="button-array">
        <template v-for="(but, index) in buttonArray">
          <el-upload v-if="but.active == 'export'" class="upload-demo" :action="but.action + but.url" :headers="headers"
            :show-file-list="false" multiple :data="but.data" :on-success="handleAvatarSuccess" :before-upload="(file) => {
              return beforeAvatarUpload(file, but);
            }
              ">
            <div class="but" type="primary" plain size="mini">{{ but.name }}</div>
          </el-upload>
          <div class="but" v-else :type="but.type" plain size="mini" @click="butClick(but.active)"
            style="margin-left: 10px;">
            {{ but.name }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import * as registrationData from "../../views/registration/registration.js";
export default {
  props: {
    width: {
      type: String,
      default: "40%",
    },
    title: {
      type: String,
      default: "标题",
    },
    dialogData: {
      type: Array,
      default: function () {
        return [{ title: "标题", type: "input", value: "" }];
      },
    },
    buttonArray: {
      type: Array,
      default: function () {
        return [
          { name: "确认", active: "sure", type: "primary" },
          { name: "取消", active: "cancel", type: "info" },
        ];
      },
    },
  },
  watch: {
    dialogData(newValue, oldValue) {
      console.log("监听", newValue);
      this.data = this.dialogData;
    },
  },
  data() {
    return {
      data: this.dialogData,
      headers: {
        token: this.$token,
      },
      action: this.$baseurl + registrationData.returnInitUrl(3),
    };
  },
  methods: {
    butClick(active) {
      this.$emit("butClick", active);
    },
    cancelDialog() {
      this.$emit("cancelDialog");
    },

    handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      if (response.code != 200) {
        this.$message.error(response.msg);
        return;
      }
      this.$message.success(response.result);
      this.$emit("butClick", 'uploadSuccess');
    },
    beforeAvatarUpload(file, but) {
      this.data.forEach(element => {
        if (element.key == 'exportWay') {
          this.$set(but.data, element.key, element.value)
        }
      });
      let type = true;
      type =
        file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.ms-excel";
      if (!type) {
        this.$message.error("上传文件只能是 excel 文件!");
      }
      return type;
    },
    clickNull() { },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
#diy-dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #00000088;
  z-index: 99;

  >.content {
    width: 30%;
    height: auto;
    max-height: 50vh;
    background-color: #fff;
    min-height: 100px;
    margin-top: 10%;
    position: relative;
    border-radius: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.116),
      0 0 6px rgba(212, 212, 212, 0.294);

    >.title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 0.8vw;
      font-weight: bolder;
      margin: 2vh 0;
    }

    >.colse {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }

    >.list {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      >.item {
        width: 100%;
        min-height: 45px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        >.tit {
          width: 120px;
          height: 100%;
          padding-right: 8px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 15px;
          font-weight: bolder;

          >.tip {
            color: rgb(236, 38, 38);
          }
        }

        >.value {
          width: 0;
          flex: 1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 30px;
          box-sizing: border-box;

          >.tip {
            width: 0;
            flex: 1;
            height: 80px;
            margin: 0 10px;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1vh 1dvb;
            border: 1px solid #ddd;
            cursor: pointer;
            transition: all 0.3s;

            >.ti {
              font-size: 0.6vw;
              color: #999;
              margin-top: 10px;
              text-align: left;
              >i{
                margin-right: 5px;
              }
            }

            >.tv {
              font-size: 1vw;
              font-weight: bolder;
            }
          }

          >.active-tip {
            background-color: #0076fc;
            color: #fff;

            >.ti {
              color: #fff;
            }
          }
        }
      }
    }

    >.button-array {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3vh 0;

      .but {
        width: 120px;
        height: 40px;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        background-color: #0076fc;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.7vw;
      }
    }
  }

  .el-select {
    width: 100%;
  }
}
</style>
